import { useMemo } from 'react';

import { PatientRemovalReason, PatientRemovalReasonQuery } from '@dreryk/egabinet-patient-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { commonTranslationKeys, createTranslatedText } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../translations';

import { PatientRemoveFormController } from './PatientRemoveForm.types';

const useCqrsSearchPatientRemovalReason = (): UseCqrsQueryResult<PatientRemovalReason[]> => {
   return useCqrsSearch<PatientRemovalReason>(() => new PatientRemovalReasonQuery());
};

const triggerLabelExtractor = (removalReason?: PatientRemovalReason): string => removalReason?.name ?? '';

type PatientRemovalReasonSelectProps = Pick<PatientRemoveFormController, 'register'>;

export const PatientRemovalReasonSelect = (props: PatientRemovalReasonSelectProps): JSX.Element => {
   const controller = props.register('removalReason', { required: true });
   const { data: patientRemovalReasons } = useCqrsSearchPatientRemovalReason();

   const items = useMemo(() => patientRemovalReasons ?? [], [patientRemovalReasons]);

   return (
      <Select<PatientRemovalReason>
         triggerLabelExtractor={triggerLabelExtractor}
         controller={controller}
         label={patientTranslationKeys.patientRemovalReason}
         placeholder={commonTranslationKeys.choose}
         testId={'removalReason'}
      >
         <Select.List items={items} keyExtractor={'id'}>
            {(item: PatientRemovalReason) => (
               <Select.Item item={item} testId={item.id} label={createTranslatedText(item.name)} />
            )}
         </Select.List>
      </Select>
   );
};
